// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merchant-info-setting .head-img-upload .el-upload--picture-card {\n  width: 80px;\n  height: 80px;\n  line-height: 88px;\n  border-radius: 50%;\n}\n.merchant-info-setting .head-img-upload .el-upload-list--picture-card .el-upload-list__item {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n}\n.merchant-info-setting .head-img-upload-btn .el-upload--picture-card {\n  width: 80px;\n  height: 80px;\n  border: 0;\n}", ""]);
// Exports
module.exports = exports;
